<div
  class="flex items-center justify-between px-4 py-3 border-t bg-project-600 border-t-project-700"
  [ngClass]="{
    'h-20': dialogHeight
  }"
>
  <div class="flex items-center space-x-1">
    <mat-form-field
      [floatLabel]="'never'"
      class="w-16 text-sm leading-[0.99rem] content-lists__page-select inline-block"
      appearance="outline"
    >
      <mat-select
        [formControl]="activePageSizeForm"
        (selectionChange)="handlePageSizeChange.emit($event.value)"
      >
        <mat-option *ngFor="let page of pager.pageSizes" [value]="page">
          {{ page }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <span class="pl-3">per page</span>
  </div>
  <div>
    <button
      class="bg-none border border-project-100 font-semibold py-1.5 px-3 mr-1 cursor-pointer text-sm hover:bg-white text-dark disabled:pointer-events-none disabled:text-project-100 disabled:border-project-100"
      [disabled]="!(pager.currentPage > 1)"
      data-testid="pager-prevButton"
      (click)="handlePageChange.emit(pager.currentPage - 1)"
    >
      Previous
    </button>
    <!-- TODO IMPROVEMENT: review classes for active page -->
    <button
      *ngFor="let pageNumber of pageNumbers"
      class="bg-none border border-project-50 font-semibold py-1.5 px-3 mr-1 cursor-pointer text-sm hover:bg-white text-dark disabled:pointer-events-none disabled:text-white"
      (click)="handlePageChange.emit(pageNumber)"
      data-testid="pager-numberButton"
      [disabled]="isActivePage(pageNumber)"
      [ngClass]="{
        'content__page-button--current': isActivePage(pageNumber)
      }"
    >
      {{ pageNumber }}
    </button>
    <button
      class="bg-none border border-project-100 font-semibold py-1.5 px-3 mr-1 cursor-pointer text-sm hover:bg-white text-dark disabled:pointer-events-none disabled:text-project-100 disabled:border-project-100"
      (click)="handlePageChange.emit(pager.currentPage + 1)"
      data-testid="pager-nextButton"
      [disabled]="
        !(pager.currentPage < Math.ceil(totalCount / pager.currentPageSize))
      "
    >
      Next
    </button>
  </div>
</div>
